import Hammer from 'hammerjs'

function hideTooltip() {
  let tooltip = document.getElementById('svg-tooltip')
  if (tooltip) {
    tooltip.style.display = 'none'
  }
}

export default {
  haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
  init: function (options) {
    let instance = options.instance, initialScale = 1, pannedX = 0, pannedY = 0

    this.hammer = Hammer(options.svgElement, {
      inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
    })

    this.hammer.get('pinch').set({
      enable: true
    })

    this.hammer.on('doubletap', function () {
      instance.zoomIn()
      hideTooltip()
    })

    this.hammer.on('panstart panmove', function (ev) {
      hideTooltip()
      if (ev.type === 'panstart') {
        pannedX = 0
        pannedY = 0
      }

      // Pan only the difference from the last event
      instance.panBy({
        x: ev.deltaX - pannedX,
        y: ev.deltaY - pannedY
      })
      pannedX = ev.deltaX
      pannedY = ev.deltaY
    })

    this.hammer.on('pinchstart pinchmove', function (ev) {
      hideTooltip()
      if (ev.type === 'pinchstart') {
        initialScale = instance.getZoom()
        instance.zoom(initialScale * ev.scale)
      }
      instance.zoom(initialScale * ev.scale)
    })

    // Prevent moving the page on some devices when panning over SVG
    options.svgElement.addEventListener('touchmove', function (e) {
      e.preventDefault()
    })
  },
  destroy: function () {
    this.hammer.destroy()
  }
}
